import { Directive, ElementRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthState } from '@app/enums/auth-state.enum';
import { AuthService } from '@app/services/auth/auth.service';

@Directive({
  selector: '[appIsNotAuthenticated]',
  standalone: true
})
export class IsNotAuthenticatedDirective {

  private readonly authService: AuthService = inject(AuthService);
  private readonly el: ElementRef = inject(ElementRef);

  constructor() {
    this.authService.authState.pipe(takeUntilDestroyed()).subscribe((state: AuthState) => {
      if (state === AuthState.IsAuthenticated) {
        this.el.nativeElement.style = 'display:none';
      } else {
        this.el.nativeElement.style = '';
      }
    })
  }

}
